import React from 'react';

export default class SvgSetter extends React.Component {
  setSize = () => {
    try {
      let $svg = document.getElementById(this.props.name).children[0]
      if (this.props.height !== undefined) {
        $svg.height.baseVal.value = this.props.height
      }
      if (this.props.width !== undefined) {
        $svg.width.baseVal.value = this.props.width
      }
    } catch (e) { }
  }
  componentDidMount = () => {
    this.setSize();
  }
  componentDidUpdate = () => {
    this.setSize();
  }
  render() {
    return (
      <div id={this.props.name}>
        {this.props.children}
      </div>
    )
  }
}